// Vuetify
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import * as labsComponents from "vuetify/labs/components";
import "../global.css";

const myCustomLightTheme = {
	dark: false,
	colors: {
		background: "#FFFFFF",
		surface: "#FFFFFF",
		primary: "#161a4f",
		"primary-darken-1": "#3700B3",
		secondary: "#03DAC6",
		"secondary-darken-1": "#018786",
		error: "#B00020",
		info: "#2196F3",
		success: "#4CAF50",
		warning: "#FB8C00",
		"surface-variant": "#161a4f",
	},
};

const vuetify = createVuetify({
	components: {
		...components,
		...labsComponents,
	},
	icons: {
		iconfont: "mdi",
	},
	theme: {
		defaultTheme: "myCustomLightTheme",
		themes: {
			myCustomLightTheme,
		},
	},
	directives,
	defaults: {
		VTextField: {
			variant: "underlined",
		},
	},
});

export default vuetify;
